import { useContext } from "react";
import { BookingFlowContext } from "../context/bookingFlowReactContext";

export function useBookingFlow() {
  const ctx = useContext(BookingFlowContext);
  if (!ctx) {
    throw new Error("useBookingFlow must be used within BookingFlowProvider");
  }
  return ctx;
}
